export default __webpack_public_path__ + "static/media/plant.288dd997.png";